import { graphcms, SEARCH_QUERY } from "Graphql/Queries";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Skeleton } from "@/components/ui/skeleton";

function SearchResult() {
  const { input } = useParams();
  const [search, setSearch] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (input.trim()) {
      setLoading(true);
      graphcms.request(SEARCH_QUERY, { search: input }).then((res) => {
        setSearch(res);
        setLoading(false);
        console.log(`Search result for ${input} is `, res);
      });
    }
  }, [input]);

  if (loading) {
    return (
      <div className="mt-10 mb-20 container flex flex-col gap-10 lg:w-10/12 mx-auto">
        <Skeleton className="h-10 w-1/2 mb-10" />
        {Array.from({ length: 3 }).map((_, i) => (
          <div key={i} className="space-y-4">
            <Skeleton className="h-8 w-1/4" />
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              <Skeleton className="h-64 w-full rounded-xl" />
              <Skeleton className="h-64 w-full rounded-xl" />
              <Skeleton className="h-64 w-full rounded-xl" />
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="mt-10 mb-20 container flex flex-col gap-20 lg:w-10/12 mx-auto">
      {search?.members?.length !== 0 &&
        search?.events?.length !== 0 &&
        search?.speakers?.length !== 0 &&
        search?.galleries?.length !== 0 && (
          <h1 className="text-3xl font-extrabold uppercase">
            Search Results for "{input}"
          </h1>
        )}
      {search?.members?.length === 0 &&
        search?.events?.length === 0 &&
        search?.speakers?.length === 0 &&
        search?.galleries?.length === 0 && (
          <h1 className="text-3xl font-extrabold uppercase">
            No results found for "{input}"
          </h1>
        )}
      {search?.members?.length !== 0 && (
        <div className="w-full flex flex-col gap-y-5 text-center">
          <h2 className="text-xl font-semibold">Members</h2>
          <div className="grid gap-10 grid-cols-fluid">
            {search?.members?.map((member) => (
              <Link
                key={member.id}
                to={`/committee?acYr=${member.academicYear}`}>
                <div
                  key={member.id}
                  className="w-56 h-92 pb-6 mb-4 bg-slate-50 mx-auto rounded-xl drop-shadow-xl text-center">
                  <img
                    className="rounded-t-xl w-56 h-72 object-cover"
                    src={member.image.url}
                    alt={`${member.title}. ${member.name}`}
                  />
                  <h3 className="text-center font-semibold mt-2">{`${member.title}. ${member.name}`}</h3>
                  <p className="text-center text-sm pb-1">{member.position}</p>
                  <p className="text-center text-sm pb-1">
                    {member.academicYear}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      )}
      {search?.events?.length !== 0 && (
        <div className="w-full flex flex-col gap-y-5 text-center">
          <h2 className="text-xl font-semibold">Events</h2>
          <div className="grid gap-10 grid-cols-fluid">
            {search?.events?.map((event) => (
              <Link to={`../event/${event.id}`} className="h-96" key={event.id}>
                <div className="card w-64 h-fit mb-4 bg-slate-50 mx-auto rounded-xl drop-shadow-xl">
                  <img
                    className=" rounded-t-xl w-64 h-auto object-cover"
                    src={event.flyerImage.url}
                    alt={event.caption}
                  />
                  <h4 className="text-center text-base font-semibold my-2">
                    {event.caption}
                  </h4>
                  <p className="text-center text-sm pb-3">{event.keywords}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      )}
      {search?.galleries?.length !== 0 && (
        <div className="w-full flex flex-col gap-y-5 text-center">
          <h2 className="text-xl font-semibold">Galleries</h2>
          <div className="grid gap-10 grid-cols-fluid">
            {search?.galleries?.map((gallery) => (
              <Link to={`/gallery/${gallery.id}`} key={gallery.id}>
                <div className="card w-60 h-fit mb-4 pb-6 bg-slate-50 mx-auto rounded-xl drop-shadow-xl">
                  <img
                    src={gallery.coverPicture.url}
                    alt={gallery.eventCategoryName}
                    className=" rounded-t-xl "
                  />
                  <h2 className="text-center font-semibold pt-3 px-1 lg:text-base 2xl:text-lg">
                    {gallery.eventCategoryName}
                  </h2>
                </div>
              </Link>
            ))}
          </div>
        </div>
      )}
      {search?.speakers?.length !== 0 && (
        <div className="w-full flex flex-col gap-y-5 text-center">
          <h2 className="text-xl font-semibold">Event Speakers</h2>
          <div className="grid gap-10 grid-cols-fluid">
            {search?.speakers?.map((speaker) =>
              speaker.events?.map((event) => (
                <Link to={`/event/${event?.id}`} key={event?.id}>
                  <div className="rounded-2xl shadow-[0_0_25px_rgba(0,0,0,0.15)] py-6 w-80">
                    <div className="w-full rounded-l-2xl border-r-2 py-5 text-center flex flex-col items-center justify-center">
                      <img
                        src={speaker.speakerImage?.url}
                        alt={`${speaker.title}. ${speaker.name}`}
                        className="w-2/3 h-auto rounded-xl border-8 p-1 border-sky-600 "
                      />
                      <p className="font-bold text-xl text-center mt-5">{`${speaker.title}. ${speaker.name}`}</p>
                      <p className="text-md text-center px-5 lg:text-base">
                        {speaker.occupation}
                      </p>
                    </div>
                  </div>
                </Link>
              )),
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default SearchResult;
